// libs
import get from 'lodash/get';

// API
import { getLandingPageData } from 'shared/api/landingpage';

// Redux Store
import { ActionTypes } from './actions';

// helpers
import { getLandingPageExperiments } from './helpers';

// types
import { IHeadersObject } from 'global';

// constants
import { INTERNATIONAL_PREFIX } from 'shared/layouts/Homepage/constants';

export const fetchHomepageData = (headers: IHeadersObject, pageName: string, isI18n: boolean) => {
  return (dispatch: any, getState: () => any) => {
    dispatch({
      type: ActionTypes.FETCH_LANDINGPAGE_DATA_PROGRESS,
    });

    const realPageName = `${isI18n ? INTERNATIONAL_PREFIX : ''}${pageName}`;

    const state = getState();

    // get the valid experiments segment for given pageName
    const experiments = getLandingPageExperiments({ pageName: realPageName, state });

    return getLandingPageData({ headers, experiments, pageName: realPageName })
      .then((data) => {
        dispatch({
          type: ActionTypes.FETCH_LANDINGPAGE_DATA_SUCCESS,
          payload: { data: get(data, 'result', []), isI18n },
        });
        return data;
      })
      .catch((err) => {
        if (err.status === 404) {
          dispatch({
            type: ActionTypes.FETCH_LANDINGPAGE_DATA_NOT_FAILED,
          });
        } else {
          dispatch({
            type: ActionTypes.FETCH_LANDINGPAGE_DATA_FAILED,
          });
        }

        return Promise.reject(err);
      });
  };
};

export const fetchLandingpageData = (headers: IHeadersObject, pageName: string) => {
  return (dispatch: any, getState: () => any) => {
    dispatch({
      type: ActionTypes.FETCH_LANDINGPAGE_DATA_PROGRESS,
    });

    const state = getState();

    // get the valid experiments segment for given pageName
    const experiments = getLandingPageExperiments({ pageName, state });

    return getLandingPageData({ headers, pageName, experiments })
      .then((data) => {
        dispatch({
          type: ActionTypes.FETCH_LANDINGPAGE_DATA_SUCCESS,
          payload: { data: get(data, 'result', []) },
        });
        return data;
      })
      .catch((err) => {
        if (err.status === 404) {
          dispatch({
            type: ActionTypes.FETCH_LANDINGPAGE_DATA_NOT_FAILED,
          });
        } else {
          dispatch({
            type: ActionTypes.FETCH_LANDINGPAGE_DATA_FAILED,
          });
        }

        return Promise.reject(err);
      });
  };
};
